<!-- main-account-list.html -->
<kilowant-header
                 [isBuyer]="true"
                 [showAccountList]="false"
                 title="Accounts"></kilowant-header>
<div class="wrapperMain mainAccountDetailsMain accountDetails">
    <div class="form buyer">
        @if (companyFilter()) {
        <div class="mt-10 mb-10 d-flex">
            <select name="filterCompany" style="width: 100%" class="grey-select f14" [(ngModel)]="selectedFilterCompany" (change)="this.refreshAccounts(true)">
                <option value="all">{{getNameForAll()}}</option>
                @for (company of userCompanies; track company) {
                <option [ngValue]="company">{{getUserCompanyName(company)}}</option>
                }
            </select>
        </div>
        }
        <div class="mt-10 mb-10 d-flex">
            <select name="viewActiveType" class="grey-select f14" [(ngModel)]="viewActiveType" (change)="this.refreshAccounts(true)">
                <option value="all">All</option>
                <option value="active">Active</option>
                <option value="inactive">Inactive</option>
            </select>
            <input type="text" name="keywords" placeholder="SEARCH" class="ml-10 search-clients" [(ngModel)]="keywords" (ngModelChange)="searchSiteInputChanged($event)" (keydown)="searchSiteInputChanged($event)" />
        </div>
        <div>
            <table mat-table
                   matSort
                   [dataSource]="accounts"
                   matSortActive="ServiceAddress"
                   matSortDisableClear="true"
                   matSortDirection="asc"
                   class="offer-summmary-table in-card-table background-transparent"
                   multiTemplateDataRows
                   #table>
                <ng-container matColumnDef="id">
                    <th mat-header-cell *matHeaderCellDef class="text-center">
                        &nbsp;&nbsp;
                    </th>
                    <td mat-cell
                        *matCellDef="let accountInfo; let i = dataIndex;"
                        class="text-center">
                        {{currentStart+i+1}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="ServiceAddress">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Address</th>
                    <td mat-cell
                        *matCellDef="let accountInfo"
                        class="cursor-pointer long-text-cut">
                        {{accountInfo.key.addressLine1}}
                        {{accountInfo.key.addressLine2}}
                    </td>
                    <ng-container matColumnDef="expandedDetail">
                        <td mat-cell
                            *matCellDef="let accountInfo; let i = dataIndex;"
                            class="no-border"
                            [attr.colspan]="displayedColumns.length">
                            <div>
                                @if (editModePos!=-1 && i === editModePos) {
                                <div class="card">
                                    <div class="body">
                                        <kilowant-account-edit [(account)]="selectedAccount!.key"
                                                               [(currentAccountNumber)]="currentAccountNumber"
                                                               [callUpdate]="callUpdate"
                                                               [callCancel]="callCancel"
                                                               [disabledDelete]="selectedAccount!.value || accounts.length<2"
                                                               (cancelled)="editCancel()"
                                                               (finished)="editFinish(0)"></kilowant-account-edit>
                                        @if (oldAccountNumbers.length>0) {
                                        <div class="account-info-block">
                                            <p class="card-block-background"
                                               [class]="(viewOldAccountNumbers[i])?'link':'link view-closed'" (click)="viewOldAccountNumbers[i]=!viewOldAccountNumbers[i]">
                                                Old Account Numbers
                                                <a [class]="(viewOldAccountNumbers[i])?'collapse':'open'"></a>
                                            </p>
                                            <div [class]="(viewOldAccountNumbers[i])?'visible':'hidden'">
                                                @for (oldAccountNumber of oldAccountNumbers; track oldAccountNumber) {
                                                <span class="mr-10 text-nowarp">{{oldAccountNumber}}</span>
                                                }
                                            </div>
                                        </div>
                                        }

                                        <div [id]="'account-consumption-'+i" class="account-info-block">
                                            <p class="card-block-background" [class]="(viewContracts[i])?'link':'link view-closed'"  (click)="viewConsumption[i]=!viewConsumption[i]">
                                                Account Consumption
                                                <a [class]="(viewConsumption[i])?'collapse':'open'"></a>
                                            </p>
                                            <div [class]="(viewConsumption[i])?'visible':'hidden'">
                                                <kilowant-account-consumption [(account)]="selectedAccount!.key"
                                                                              [callUpdate]="callUpdate"
                                                                              [callCancel]="callCancel"
                                                                              [activated]="(viewConsumption[i])"
                                                                              (cancelled)="editCancel()"
                                                                              (finished)="editFinish(1)"></kilowant-account-consumption>
                                            </div>
                                        </div>
                                        @if (selectedAccount!.key.billImages == null || selectedAccount!.key.billImages.length == 0) {
                                        <div class="account-info-block card-block-background view-closed">
                                            No Documents
                                        </div>
                                        }
                                        @if (selectedAccount!.key.billImages != null && selectedAccount!.key.billImages.length > 0) {
                                        <div class="account-info-block">
                                            <p class="card-block-background" style="cursor:pointer;" [class]="(viewDocuments[i])?'link':'link view-closed'"
                                               (click)="viewDocuments[i]=!viewDocuments[i]">
                                                Documents
                                                <a [class]="(viewDocuments[i])?'collapse':'open'"></a>
                                            </p>
                                            <div [class]="(viewDocuments[i])?'visible':'hidden'">
                                                <table style="width:100%; border-collapse:collapse;">
                                                    <thead>
                                                        <tr>
                                                            <th class="accountInfoBorder" style="text-align:left; padding: 6px 0;">Type</th>
                                                            <th class="accountInfoBorder" style="text-align:left; padding: 6px 0;">Uploaded</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        @for (doc of selectedAccount!.key.billImages; track doc) {
                                                        <tr style="cursor:pointer;" (click)="downloadFileFromView(doc.id)">
                                                            <td class="subUniqueTitle" style="padding: 6px 0;">Bill</td>
                                                            <td class="subUniqueTitle" style="padding: 6px 0;">{{doc.dateCreated | date:'shortDate'}}</td>
                                                        </tr>
                                                        }
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                        }
                                        @if (i==editModePos && this.errorY().showError() && errorY().error!='accountissue') {
                                        <div class="error-block">
                                            {{this.errorY().error}}
                                        </div>
                                        }
                                        @if (i==editModePos && this.errorY().showError() && errorY().error=='accountissue') {
                                        <div class="error-block">
                                            The account number you entered is already in use. Please verify the number and try again. If you believe that your account number has been used without your authorization, please <a (click)="reportAccountIssue()">click here</a> to report it to kilowant for investigation.
                                        </div>
                                        }
                                        @if (i==editModePos) {
                                        <div class="block-buttons full-width small mt-20">
                                            <button type="button" (click)="cancel()">Cancel</button>
                                            <button type="button" (click)="updateAccount()">
                                                Update
                                            </button>
                                            <button type="button"
                                                    [disabled]="selectedAccount!.value || accounts.length<2"
                                                    (click)="deleteAccount(selectedAccount!.key)">
                                                Delete
                                            </button>
                                        </div>
                                        }
                                    </div>
                                </div>
                                }
                            </div>
                        </td>
                    </ng-container>
                </ng-container>
                <ng-container matColumnDef="AccountNumber">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                        Account Number
                    </th>
                    <td mat-cell
                        *matCellDef="let accountInfo"
                        class="cursor-pointer long-text-cut">
                        {{accountInfo.key.accountNumber}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="RateClass">
                    <th mat-header-cell *matHeaderCellDef class="text-center">Rate Class</th>
                    <td mat-cell
                        *matCellDef="let accountInfo"
                        class="cursor-pointer long-text-cut text-center">
                        {{(accountInfo.key.rateClass==null)?"-":accountInfo.key.rateClass.name}}
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row
                    *matRowDef="let accountInfo; let i = dataIndex; let row; columns: displayedColumns;"
                    (click)="editAccount(i, false)"
                    [class]="((i==editModePos)?'selected':'') + ((accountInfo.key.isActive)?'':' inactive')"></tr>
                <tr mat-row
                    *matRowDef="let row; columns: ['expandedDetail']"
                    class="b-none"></tr>
            </table>
            <mat-paginator [length]="total"
                           hidePageSize="true"
                           [pageSize]="RECS_PER_PAGE"
                           aria-label="Select page"></mat-paginator>
        </div>
        <div class="block-buttons under-card">
            <button type="button" (click)="addAccount()">
                Add Account
            </button>
        </div>
    </div>
</div>
